<template>
  <article class="category flex flex-col">
    <BaseTheContentBreadcrumbs
      v-if="category"
      :current-page-title="category.title"
    />
    <h1
      v-if="category"
      class="mb-[24px] text-center font-roboto text-[32px] font-medium leading-6 text-specialprojectsection"
    >
      {{ category.title }}
    </h1>
    <div
      class="grid grid-cols-1 gap-[20px] md:grid-cols-3 xl:grid-cols-4 2xl:grid-cols-5 3xl:grid-cols-6"
    >
      <MainPageCardsReworkedDocumentsCard
        v-for="document in documents"
        :key="document.id"
        class="col-span-1 min-h-[401px]"
        :data="getDocumentCardData(document)"
      />
    </div>
  </article>
</template>

<script setup>
const route = useRoute();
const slug = route?.params?.slug;

const { categorySlug } = useDocumentByCategorySlug(slug);

useErrorHandler(() => categorySlug.failureReason.value?.status);

const documents = computed(() => categorySlug?.data?.value?.data);
const category = computed(() => categorySlug?.data?.value?.category);

const getDocumentCardData = (document) => {
  return {
    title: document.title,
    url: `/read/documents/${category.value.slug}/${document.slug}`,
    image: document.images?.[0],
  };
};

const { canonicalUrl, title } = useSeoHelper();

useHead(() => ({
  title: title(
    'Исторические документы РФ | Читать на Федеральном портале Истории России',
  ),
  meta: [
    {
      hid: 'description',
      name: 'description',
      content:
        'Документы, подтверждающие или описывающие реальные события Российской истории из первых уст. Российское военно-историческое общество. Мы знаем правду.',
    },
    {
      property: 'og:image',
      content: `${useHostApp()}${
        category.value?.image?.src ?? category.value?.image?.preview
      }`,
    },
    {
      hid: 'og:type',
      property: 'og:type',
      content: 'article',
    },
    {
      property: 'og:title',
      content: title(
        'Исторические документы РФ | Читать на Федеральном портале Истории России',
      ),
    },
    {
      property: 'og:url',
      content: `${useHostApp()}/read/documents/${slug}`,
    },
    {
      property: 'og:description',
      content:
        'Документы, подтверждающие или описывающие реальные события Российской истории из первых уст. Российское военно-историческое общество. Мы знаем правду.',
    },
  ],
  link: [
    {
      rel: 'canonical',
      href: canonicalUrl.value,
    },
  ],
}));
</script>
